import Bar from "./bar";
import Circular from "./circular";

export default { Bar, Circular };
